import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Button as MuiButton, Box } from '@mui/material'
import { darkTheme, lightTheme } from '../theme'

export default function Button(props) {
  const { variant, minWidth, minHeight, onClick, disabled, startIcon, sx, children, ...other } = props

  const darkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true })

  const theme = createTheme(darkMode ? darkTheme() : lightTheme())

  theme.palette.action.disabledBackground = theme.palette.main
  theme.palette.action.disabled = theme.palette.text.main

  return (
    <ThemeProvider theme={theme}>
      <MuiButton
        variant={variant || 'contained'}
        disableElevation
        onClick={onClick}
        disabled={disabled}
        startIcon={startIcon}
        sx={{
          '&.Mui-disabled': {
            opacity: 0.4
          },
          display: startIcon && 'inline-flex',
          borderRadius: 22,
          textTransform: 'none',
          minWidth,
          minHeight,
          ...sx
        }}
        {...other}
      >
        {startIcon ? <Box sx={{ mr: 'auto' }}>{children}</Box> : children}
      </MuiButton>
    </ThemeProvider>
  )
}
